import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { cloneDeep } from "lodash";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../records/server/query";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../../../../records/utils";
import {
  ProgressiveDefinition,
  ProgressiveDefinitionGame,
} from "../../../models/progressiveDefinition";

const machineConfigurationGridId = Symbol(
  "main.machines.progressives.detail.progressiveMachines"
);

export class ProgressivesDetailComponentController implements IOnInit {
  static $inject = [GridSettingsServiceName, RecordsUtilsServiceName, "$state"];

  readonly defaultQuery: IQuery = {};
  readonly gridSettings: IGridSettings;

  /* bindings */
  private readonly progressiveDefinition!: ProgressiveDefinition;
  /* end bindings */

  constructor(
    gridSettingsService: GridSettingsService,
    private readonly recordUtils: RecordsUtilsService,
    private readonly $state: StateService
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      machineConfigurationGridId
    );
  }

  clone() {
    const newProgressive = cloneDeep(this.progressiveDefinition);
    this.recordUtils.stripIds(newProgressive);
    this.$state.go("main.machines.progressives.add", {
      progressiveDefinition: newProgressive,
    });
  }

  $onInit(): void {
  }

  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  getGameHeader(game: ProgressiveDefinitionGame): string {
    return `${game.GameProgramNumber} - ${game.PaytableId}`;
  }
}
